<style scoped>
  .m-body .m-content {
    padding-bottom: 0;
  }

  #messages_container {
    overflow-y: scroll;
    max-height: 560px;
  }

  .support_message {
    margin-top: 15px;
    width: 60%;
  }

  .support_message.from_admin {
    margin-left: 40%;
  }

  .support_message.from_user span.message_time {
    display: block;
    text-align: right;
  }

  .support_message.from_admin span.message_time {
    display: block;
    text-align: left;
  }

  .support_message .user_logo {
    float: left;
    overflow: hidden;
    border-radius: 50%;
    background: white;
  }

  .support_message.from_admin .user_logo {
    float: right;
    margin-right: 15px;
  }

  .support_message .user_logo img {
    width: 50px;
    height: 50px;
  }

  .support_message .message_content {
    position: relative;
    width: calc(100% - 75px);
    display: inline-block;
    margin-left: 25px;
    background: white;
    padding: 10px;
    border-radius: 0px 10px 10px 10px;
  }

  .support_message.from_admin .message_content {
    width: calc(100% - 90px);
    border: 0;
    border-radius: 10px 0px 10px 10px;
    float: right;
    margin: 0;
    margin-right: 25px;
    background: #48a6a6;
    color: white;
  }

  .support_message .message_content:before {
    content: "";
    position: absolute;
    height: 0;
    width: 0;
    right: 100%;
    top: 0;
    border: 15px solid transparent;
  }

  .support_message.from_user .message_content:before {
    border-right: 0 solid white;
    border-top: 20px solid white;
  }

  .support_message.from_admin .message_content:before {
    right: 0;
    left: 100%;
    border-left: 0 solid #22b9ff;
    border-top: 20px solid #22b9ff;
  }

  .support_message .message_content ul {
    margin: 0;
    padding: 0;
  }

  .support_message .message_content ul li {
    width: 25%;
    float: left;
    text-align: center;
    display: inline-block;
  }

  .support_message .message_content ul li a {
    text-decoration: none;
    color: #0091d5;
    font-weight: 500;
  }

  .support_message.from_admin .message_content ul li a {
    color: white;
  }

  .support_message .message_content ul li a .attachment_icon {
    padding: 10px;
  }

  .support_message .message_content ul li a .attachment_icon i {
    font-size: 66px;
    color: #0091d5;
  }

  .support_message.from_admin .message_content ul li a .attachment_icon i {
    color: white;
  }

  .support_message .message_content ul li a span {
    width: 80px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
  }

  .support_message .message_content a:hover {
    color: #2739c1;
  }

  .support_message.from_admin .message_content a {
    color: black;
  }

  /* width */
  #messages_container::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  #messages_container::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  #messages_container::-webkit-scrollbar-thumb {
    background: #22b9ff;
  }

  /* Handle on hover */
  #messages_container::-webkit-scrollbar-thumb:hover {
    background: #43b3e7;
  }

  textarea {
    resize: vertical;
  }

  .dropzone {
    border: 2px solid #22b9ff;
  }

  select.form-control {
    padding: 0;
    padding-left: 10px;
  }
</style>
<template>
  <div class="new_ticket" >
    <form class="forms-sample" style="margin-bottom: 0; border-bottom: 1px solid rgba(0, 0, 0, 0.1)">
      <h6 class="sub-title mb-3 color-default" style="border: 0; margin: 0 !important; padding: 0">
        {{ formHeader }}
      </h6>
    </form>
  
    <form class="forms-sample" :key="this.$route.params.ticket" style="margin-top: 0">
      <div class="form-group row">
        <div class="col-md-12" style="border-left: 1px solid rgba(0, 0, 0, 0.1)">
          <div class="col-md-12">
            <div class="form-group">
              <label>Select Organization</label>
              <multiselect :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" :options="organizations" :allow-empty="false" :searchable="true" v-model="ticketForm.org"
                label="name" track-by="organization_id">
              </multiselect>
            </div>
          </div>
          <div class="col-md-12">
            <label class="label-form" for="message">Title:</label>
            <input v-model="ticketForm.title" class="form-control" type="text" />
          </div>
          <br />
          <div class="col-md-12">
            <div class="form-group">
              <label>What do you need help with?</label>
              <select v-model="ticketForm.category" class="form-control" style="padding: 5px 10px"
                placeholder="Select category">
                <option v-for="(value, index) in category" :key="index">
                  {{ value }}
                </option>
              </select>
            </div>
          </div>
          <!-- title input -->
          <div class="col-md-12">
            <label class="label-form" for="message">Message:</label>
            <tiny-mce-editor :vModelName.sync="ticketForm.message"></tiny-mce-editor>
            <!-- <textarea id="message" v-model="ticketForm.message" placeholder="Message" class="form-control"></textarea> -->
          </div>
          <br />
          <!-- caption input -->
          <div class="col-md-12">
            <vue-dropzone ref="myVueDropzone" id="dropAttach" :options="dropzoneOptions"></vue-dropzone>
          </div>
          <div class="col-md-12" style="padding-top: 20px">
            <input type="checkbox" data-toggle="modal" @click="check($event)" v-model="ticketForm.add_trello" />
            <span class="checkmark"></span>
            Add To Trello
          </div>
          <div v-if="is_show_trello">
            <br />
            <div class="col-md-12">
              <div class="form-group">
                <label>Select board list:</label>
                <select v-model="ticketForm.list_id" class="form-control" style="padding: 5px 10px"
                  placeholder="Select list">
                  <option v-for="(index, list) in board_lists" :key="index">
                    {{ list.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <label class="label-form" for="message">Card Title:</label>
              <input v-model="ticketForm.list_card_title" class="form-control" type="text" />
            </div>
            <div class="col-md-12">
              <label class="label-form" for="message">Card Description:</label>
              <textarea v-model="ticketForm.list_card_desc" class="form-control" type="text" rows="4"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="text-right">
          <button class="btn btn-primary" @click.prevent="save">Submit</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from "axios";
  import "jodit/build/jodit.min.css";
  import JoditVue from "jodit-vue";
  import TinymceEditor from "../../views/partials/tiny_mce_editor";
  import Multiselect from "vue-multiselect";
  import moment from "moment";
  import vue2Dropzone from "vue2-dropzone";
  import "vue2-dropzone/dist/vue2Dropzone.min.css";

  Vue.filter("formatDateTime", function (value) {
    if (value) {
      return (
        moment(String(value)).format("DD MMMM, YYYY") +
        " at " +
        moment(String(value)).format("hh:mm:ss A")
      );
    }
  });

  export default {
    components: {
      JoditVue,
      Multiselect,
      vueDropzone: vue2Dropzone,
      "tiny-mce-editor": TinymceEditor,
    },

    data: function () {
      var supportedImageFormats = [
        ".jpeg",
        ".jfif",
        ".tiff",
        ".bmp",
        ".jpg",
        ".png",
        ".gif",
      ];
      var supportedDocumentFormats = [
        ".docx",
        ".rtf",
        ".doc",
        ".pdf",
        ".txt",
        ".xls",
        ".xlsx",
      ];
      var supportedVideoFormats = [".mp4", ".avi", ".flv", ".wmv", ".mov"];
      var supportedAudioFormats = [".mp3", ".wav", ".aac"];
      var unique_folder = Math.floor(Math.random() * 90000) + 10000;

      return {
        formHeader: "",
        user_logo: "",
        board_lists: [],
        organizations: [],
        Regex: "a-zA-Z]*$/",
        main_site_url: process.env.VUE_APP_LINENTECH_V3,
        ticketForm: {
          id: 0,
          user_id: 0,
          title: "",
          category: "",
          add_trello: false,
          org: "",
          list_id: "",
          list_card_title: "",
          list_card_desc: "",
          customer_feedback: false,
        },
        category: [
          "General Question",
          "Customization or New Feature Request",
          "Bug/System Error Report",
          "System Improvement Suggestion",
          "Request a call back",
          "Request a zoom meeting",
        ],
        is_show_trello: false,
        supportedImageFormats: supportedImageFormats,
        supportedDocumentFormats: supportedDocumentFormats,
        supportedVideoFormats: supportedVideoFormats,
        supportedAudioFormats: supportedAudioFormats,
        unique_folder: unique_folder,

        buttons: [
          "bold",
          "strikethrough",
          "underline",
          "italic",
          "|",
          "ul",
          "ol",
          "|",
          "image",
          "table",
          "link",
          "|",
          "outdent",
          "indent",
          "|",
          "align",
          "undo",
          "redo",
          "|",
          "hr",
          "symbol",
          "fullsize",
        ],
        config: {
          uploader: {
            insertImageAsBase64URI: true,
          },
        },
        dropzoneOptions: {
          url: process.env.VUE_APP_LINENTECH_V3 + "/upload", // This is broken link which is not going to upload image.
          maxFilesize: 12,
          acceptedFiles:
            supportedImageFormats.join(", ") +
            "," +
            supportedDocumentFormats.join(", ") +
            "," +
            supportedVideoFormats.join(", ") +
            "," +
            supportedAudioFormats.join(", "),
          addRemoveLinks: true,
          timeout: 50000,
          success: function (file, response, xhr) { },
          error: function (file, response, xhr) {
            if (response == "You can't upload files of this type.") {
              var fileRef;
              (fileRef = file.previewElement) != null
                ? fileRef.parentNode.removeChild(file.previewElement)
                : void 0;
              alert(
                response +
                "\n" +
                "Here is the list of supported files:" +
                "\n" +
                "Support image formats: " +
                supportedImageFormats.join(", ") +
                "\n" +
                "Support document formats: " +
                supportedDocumentFormats.join(", ") +
                "\n" +
                "Support audio formats: " +
                supportedAudioFormats.join(", ") +
                "\n" +
                "Support video formats: " +
                supportedVideoFormats.join(", ") +
                "\n"
              );
            }
            return false;
          },
        },
      };
    },

    computed: {},
    created: function () {
      this.getlist();
      this.getOrg();
    },

    methods: {
      async getOrg() {
        let loader = this.$loading.show({
          loader: "dots",
        });
        const permission = {
      headers: {
        'X-Permission': 'all_organization_list' 
      }
    };
        await axios
          .get("/admin/users/get-all-organizations",permission)
          .then((response) => {
            this.organizations = response.data;
            loader.hide();
          })
          .catch((error) => {
            loader.hide();
          });
      },
      check(e) {
        if (e.target.checked) {
          this.is_show_trello = true;
        } else {
          this.is_show_trello = false;
        }
      },
      getlist() {
        var url = "/support/get-board-list";
        axios
          .post(url, {
            _method: "GET",
          })
          .then((response) => {
            this.board_lists = response.data.data;
          });
      },
      empty(str) {
        return !str || !/[^\s]+/.test(str);
      },
      save() {
        if (
          this.ticketForm.org == "" ||
          this.ticketForm.message == "" ||
          this.ticketForm.message == undefined ||
          this.ticketForm.category === "" ||
          this.ticketForm.category == undefined
        ) {
          this.$store.dispatch(
            "message/update",
            {
              title: "Alert",
              body: `Field can not be empty.`,
              class: "warning",
              confirm: false,
            },
            { root: true }
          );

          return;
        }
        if (this.ticketForm.add_trello) {
          if (
            this.empty(this.ticketForm.list_card_title) ||
            this.ticketForm.list_id == "" ||
            this.empty(this.ticketForm.list_card_desc)
          ) {
            this.$store.dispatch(
              "message/update",
              {
                title: "Alert",
                body: `Field can not be empty.`,
                class: "warning",
                confirm: false,
              },
              { root: true }
            );
            return;
          }
        }
        this.sendReply(this.ticketForm);
      },

      // Send Reply to ticket
      sendReply(ticket) {
        let loader = this.$loading.show({
          loader: "dots",
        });
        this.ticketForm.attachment = this.$refs.myVueDropzone.getAcceptedFiles();
        this.$store
          .dispatch("support/sendReply", ticket)
          .then((data) => {
            // send successful message
            loader.hide();
            this.$store.dispatch(
              "message/update",
              {
                title: this.formHeader,
                body: `Message has been sent successfully`,
                class: "success",
                confirm: false,
              },
              { root: true }
            );

            this.$router.push("/support");
          })
          .catch((error) => {
            let response = error.response;
            loader.hide();
            // send error message
            this.$store.dispatch(
              "message/update",
              {
                title: this.formHeader,
                body: `Message has been sent successfully`,
                // itemsErrors: response.data.errors,
                class: "success",
                confirm: false,
              },
              { root: true }
            );
            this.$router.push("/support");
          });
      },
    },
  };
</script>
<style scoped>
@media (min-width: 320px) and (max-width:480px){
  #border_left{
    border-left: 0px !important;   
  }
  .forms-sample{
    display: flex;
    align-items: center!important;
    justify-content: center!important;
  }
}
</style>